export default __webpack_public_path__ + "static/screenThirdSectionEn-d5e079952cdf27d20dfaeafc300f0526.webp";